(function () {
  "use strict";

  // Ao clicar em um plano antes do cadastro
  $(".btn-plano-cad").on("click", function (ev) {
    ev.preventDefault();
    const planoId = $(this).data("plano");
    $("#cd-plano").val(planoId);
    $("#cadastro_retorno").val(
      url_base +
        "minha-conta/anuncio/cadastrar/plano/" +
        planoId +
        "/cad-success"
    );
    openModal("modal-cadastro");
  });

  // Ao clicar em um plano depois do cadastro
  $(".btn-plano-cad-ok").on("click", function (ev) {
    ev.preventDefault();
    const planoId = $(this).data("plano");
    window.location.href = url_base +
        "minha-conta/anuncio/cadastrar/plano/" +
        planoId 
  });
})();
